var _circle, _g, _circle2, _g2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGear3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bronze-metal-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#cd7f32",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    style: {
      stopColor: "#7c503a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#4a2c20",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowing-edge",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    style: {
      stopColor: "#ff9933",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    fill: "url(#bronze-metal-gradient)",
    stroke: "#333333",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#glowing-edge)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 5,
    transform: "rotate(0 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 5,
    transform: "rotate(30 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 5,
    transform: "rotate(60 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 5,
    transform: "rotate(90 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 5,
    transform: "rotate(120 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 5,
    transform: "rotate(150 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 5,
    transform: "rotate(180 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 5,
    transform: "rotate(210 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 5,
    transform: "rotate(240 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 5,
    transform: "rotate(270 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 5,
    transform: "rotate(300 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 45,
    width: 8,
    height: 5,
    transform: "rotate(330 50 50)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30,
    fill: "rgba(205, 127, 50, 0.5)",
    stroke: "#4B3621",
    strokeWidth: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: -15,
    r: 1.5,
    fill: "#7c503a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: -15,
    r: 1.5,
    fill: "#7c503a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: 15,
    r: 1.5,
    fill: "#7c503a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 1.5,
    fill: "#7c503a"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 6,
    fill: "url(#glowing-edge)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 3,
    fill: "#ff9933"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear3);
export default __webpack_public_path__ + "static/media/gear3.f3dae67c456b234e2d73dffe05f45290.svg";
export { ForwardRef as ReactComponent };